import Vue from 'vue'
import App from './App'
import ProgressBar from './components/progress/vue-progressbar.es5'

/* eslint-disable no-new */
Vue.use(ProgressBar, {
  debug: true,
  color: '#bffaf3',
  failedColor: '#CF2020',
  thickness: '5px',
  transition: {
    time: '0.7s',
    opacity: '0.6s'
  },
  trail: '100px',
  autoRevert: true,
  location: 'top',
  inverse: false,
  gradient: {
    use: false,
    gradient: 'predefined'
  },
  init: true
})

new Vue({
  el: '#app',
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js